import felixAvatarUrl from "@/assets/felix-avatar.jpg";

/**
 * Identity of the AI agent that talks to contacts on WhatsApp.
 *
 * Outbound (assistant) messages in the conversation are attributed to Felix.
 * Human operators sending from the CRM are rendered separately (see
 * `ChatSender === "operator"`), but still sit on the same outbound side.
 */
export const FELIX = {
  name: "Felix",
  /**
   * Resolved (hashed) URL produced by Vite's asset pipeline. Importing the
   * image as a module — rather than referencing `public/` — keeps the URL
   * correct under the app's relative `base: "./"` on deeply nested routes.
   */
  avatarUrl: felixAvatarUrl as string,
} as const;
